import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';
import { SpotDetails, SpotListCTAThumbnail, SpotThumbnail } from '@surfline/quiver-react';
import { slugify } from '@surfline/web-common';
import { spotReportPath } from '@surfline/web-common/dist/paths/kbyg';
import spotPropType from '../../propTypes/spot';
import unitsPropType from '../../propTypes/units';

const getBackgroundImg = spot => (spot.cameras[0] ? spot.cameras[0].stillUrl : null);

const SpotMarkerTooltip = ({ spot, units, position, showPremiumCamCTA }) => {
  const renderSpotThumbnail = showPremiumCamCTA ? (
    <SpotListCTAThumbnail spot={spot} isTooltip />
  ) : (
    <SpotThumbnail
      windDirection={spot.wind.direction}
      windSpeed={spot.wind.speed}
      units={units}
      hasCamera={spot.cameras.length > 0}
    />
  );

  return (
    <Link
      className={`sl-spot-marker-tooltip sl-spot-marker-tooltip--${position.vertical}${position.horizontal}`}
      to={spotReportPath(slugify(spot.name), spot._id)}
      style={{ backgroundImage: `url('${getBackgroundImg(spot)}')` }}
      title={`${spot.name} Surf Report & Forecast`}
    >
      {spot.cameras[0] ? renderSpotThumbnail : null}
      <SpotDetails spot={spot} units={units} />
    </Link>
  );
};

SpotMarkerTooltip.propTypes = {
  spot: spotPropType.isRequired,
  units: unitsPropType.isRequired,
  position: PropTypes.shape({
    vertical: PropTypes.string,
    horizontal: PropTypes.string,
  }),
  showPremiumCamCTA: PropTypes.bool,
};

SpotMarkerTooltip.defaultProps = {
  position: {
    vertical: 'top',
    horizontal: 'center',
  },
  showPremiumCamCTA: false,
};

export default SpotMarkerTooltip;
